const padTime = (time) => {
  const pad = '00';
  time = time += '';

  return pad.substring(0, pad.length - time.length) + time;
};

const toString = (time) => {
  let hoursString = '00h ';
  let minutesString = '00min ';
  let secondsString = '00s';
  let seconds = Math.floor(time / 1000);
  let minutes = Math.floor(seconds / 60);

  seconds = seconds - (minutes * 60);

  const hours = Math.round(minutes / 60);

  minutes = minutes - hours * 60;

  if (hours > 0) {
    hoursString = `${padTime(hours)}h `;
  }

  if (minutes > 0) {
    minutesString = `${padTime(minutes)}min `;
  }

  secondsString = `${seconds}s`;

  return `${hoursString}${minutesString}${secondsString}`;
};

export {
  toString,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/time/index.js
 **/